import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import ComponentHeader from "../Header/ComponentHeader";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { calculateAverageAge, isCurrentYear } from "../../Helpers/CommonHelper";
import { useInView } from "react-intersection-observer";
import KeyFigureNew from "../Elements/KeyFigureNew";
import EmptySpace from "../Elements/EmptySpace";
import { periodToComma } from "../../Helpers/CommonHelper";
import {
  headingSmall,
  headingLarge,
  HeadingMunicipality,
  FiguresWrapper,
  heading48
} from "../../Util/StyleProps";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  margin-bottom: 48px;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const AgeContainer = props => {
  const { data, sweden, blockColor, scroll } = props;

  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });

  //periodToComma
  const lastYear = sweden.age.year;
  const swedenMedium = sweden.age.total;
  const swedenString =
    "I Sverige är medelåldern " +
    periodToComma(swedenMedium) +
    " år. Medelåldern är " +
    periodToComma(sweden.age.female) +
    " år för kvinnor och " +
    periodToComma(sweden.age.male) +
    " år för män (" +
    lastYear +
    ").";

  let municipality1 = data[0];
  let municipality2 = data[1];

  // Accessibility
  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "är"
        : "var"
      : "";

    return municipality
      ? `År ${municipality.year} ${str} medelåldern i ${
          municipality.name
        } kommun ${
          municipality.total
        }år. Medelåldern för kvinnor ${str} ${
          municipality.female
        }år och medelåldern för män ${str} ${municipality.male} år.`
      : "";
  };

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M24.2567 76.1541L21.2175 73.9233L29.545 62.3716H21.4042C21.8014 57.1666 22.5961 52.1144 23.7884 47.215C24.9806 42.315 26.4295 37.9405 28.135 34.0916C29.8184 30.2272 31.6386 27.1411 33.5959 24.8333C35.5531 22.5255 37.5234 21.3716 39.5067 21.3716C40.8911 21.3716 42.0534 21.8908 42.9934 22.9291C43.9339 23.968 44.917 25.5772 45.9425 27.7566C47.2459 30.4188 48.9061 32.5641 50.9234 34.1925C52.94 35.8208 55.4228 37.2352 58.3717 38.4358C58.7178 38.0852 59.1248 37.8255 59.5925 37.6566C60.0609 37.4883 60.5428 37.4041 61.0384 37.4041C62.295 37.4041 63.4136 37.8858 64.3942 38.8491C65.3748 39.813 65.865 40.9125 65.865 42.1474V76.1541H63.5259V42.1474C63.5259 41.5108 63.2842 40.9511 62.8009 40.4683C62.3181 39.985 61.7584 39.7433 61.1217 39.7433C60.485 39.7433 59.9253 39.985 59.4425 40.4683C58.9592 40.9511 58.7175 41.5108 58.7175 42.1474V44.1025H56.3784V41.6733C53.9211 40.7288 51.4692 39.2713 49.0225 37.3008C46.5759 35.3308 44.6539 33.2305 43.2567 31L39.9167 42.7566L48.205 61.0574V76.1541H44.4234V62.3716H34.2567L24.2567 76.1541ZM43.8525 16.84C42.2842 16.84 40.937 16.2822 39.8109 15.1666C38.6848 14.0511 38.1217 12.6986 38.1217 11.1091C38.1217 10.8825 38.2222 10.3141 38.4234 9.40412C37.9106 9.1819 37.4981 8.8344 37.1859 8.36162C36.8742 7.88885 36.7184 7.37107 36.7184 6.80829C36.7184 6.02162 36.9906 5.35273 37.535 4.80162C38.08 4.24995 38.7542 3.97412 39.5575 3.97412C40.1192 3.97412 40.6356 4.13023 41.1067 4.44245C41.5784 4.75412 41.9261 5.16635 42.15 5.67912C42.4045 5.58968 42.69 5.51717 43.0067 5.46162C43.3228 5.40606 43.6061 5.37829 43.8567 5.37829C45.435 5.37829 46.7842 5.94134 47.9042 7.06745C49.0236 8.19356 49.5834 9.54079 49.5834 11.1091C49.5834 12.6986 49.0256 14.0511 47.91 15.1666C46.795 16.2822 45.4425 16.84 43.8525 16.84Z" fill="#0F0865"/>
        <path d="M24.2567 76.1541L21.2175 73.9232L29.545 62.3716H21.4042C21.8014 57.1666 22.5961 52.1144 23.7884 47.2149C24.9806 42.3149 26.4295 37.9405 28.135 34.0916C29.8184 30.2271 31.6386 27.141 33.5959 24.8332C35.5531 22.5255 37.5234 21.3716 39.5067 21.3716C40.8911 21.3716 42.0534 21.8907 42.9934 22.9291C43.9339 23.968 44.917 25.5771 45.9425 27.7566C47.2459 30.4188 48.9061 32.5641 50.9234 34.1924C52.94 35.8207 55.4228 37.2352 58.3717 38.4357C58.7178 38.0852 59.1248 37.8255 59.5925 37.6566C60.0609 37.4882 60.5428 37.4041 61.0384 37.4041C62.295 37.4041 63.4136 37.8857 64.3942 38.8491C65.3748 39.813 65.865 40.9124 65.865 42.1474V76.1541H63.5259V42.1474C63.5259 41.5107 63.2842 40.951 62.8009 40.4682C62.3181 39.9849 61.7584 39.7432 61.1217 39.7432C60.485 39.7432 59.9253 39.9849 59.4425 40.4682C58.9592 40.951 58.7175 41.5107 58.7175 42.1474V44.1024H56.3784V41.6732C53.9211 40.7288 51.4692 39.2713 49.0225 37.3007C46.5759 35.3307 44.6539 33.2305 43.2567 30.9999L39.9167 42.7566L48.205 61.0574V76.1541H44.4234V62.3716H34.2567L24.2567 76.1541Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader heading={"Så är vår medelålder"} text={swedenString} />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality1)}
                    marginBottom="24px"
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                  >
                    <div>{municipality1 ? Number(municipality1.total).toLocaleString('sv-SE') : 0}</div>
                    <div className="label">år är medelåldern</div>
                  </AnimatedDiv>
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={0.75}
                    iconName={"female"}
                    alt="Ikon kvinna"
                    size={heading48}
                    value={municipality1.female}
                    subText={" år för kvinnor"}
                  />
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={0.75}
                    iconName={"male"}
                    alt="Ikon man"
                    size={heading48}
                    value={municipality1.male}
                    subText={"år för män"}
                    marginBottom={"0px"}
                  />
                </SvgLayout>
              ) : (
                <div></div>
              )}
              {municipality2 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality2)}
                    marginBottom="24px"
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                    style={{
                      color: secondaryColor,
                    }}
                  >
                    <div>{municipality2 ? Number(municipality2.total).toLocaleString('sv-SE') : 0}</div>
                    <div className="label">år är medelåldern</div>
                  </AnimatedDiv>
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={1.75}
                    iconName={"female"}
                    alt="Ikon kvinna"
                    size={heading48}
                    value={municipality2.female}
                    subText={"år för kvinnor"}
                  />
                  <KeyFigureNew
                    triggerAnimation={inView}
                    delay={1.75}
                    iconName={"male"}
                    alt="Ikon man"
                    size={heading48}
                    value={municipality2.male}
                    subText={"år för män"}
                    marginBottom={"0px"}
                  />
                </SvgLayout>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

AgeContainer.defaultProps = {
  data: [],
  sweden: {}
};

export default AgeContainer;
